import styled from "styled-components";


export const ChartWrapperStyled = styled.div`
    position: relative;
`;